import "../Sidebar/sidebar.scss";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import logo from "../../Images/KYABRS.png";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import Drawer from "@mui/material/Drawer";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { MdVolunteerActivism } from "react-icons/md";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import { GoDotFill } from "react-icons/go";
import { FaNotesMedical } from "react-icons/fa";
import { HorizontalRule } from "../../components/Volunteer/Volunteer.style";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SecurityIcon from "@mui/icons-material/Security";
import useProfile from "../../hooks/useProfile";
import useDashboardPermission from "../../hooks/useDashboardPermission";

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const Sidebar = () => {
  const open = useSelector((state) => state.NavSidebar.open);
  const [userData] = useProfile();

  const [dashboardPermissionData] = useDashboardPermission();

  const [select, setSelect] = useState(1);

  const [dropFirst, setDropFirst] = useState(false);
  const [dropSecond, setDropSecond] = useState(false);
  const [dropThird, setDropThird] = useState(false);
  const [dropFourth, setDropFourth] = useState(false);

  const objects = {};

  dashboardPermissionData.forEach((item) => {
    const variableName = `a${item.sa_mlinks_id}b`;
    objects[variableName] = {
      sa_mlinks_id: item.sa_mlinks_id,
      active_fg: item.active_fg,
    };
  });

  const handleDashboard = () => {
    setSelect(1);
    setDropFirst(false);
    setDropSecond(false);
    setDropThird(false);
    setDropFourth(false);
  };

  const handleFirst = () => {
    if (!dropFirst) {
      setDropFirst(true);
      setDropSecond(false);
      setDropThird(false);
      setDropFourth(false);
    } else {
      setDropFirst(false);
    }
  };

  const handleSecond = () => {
    if (!dropSecond) {
      setDropSecond(true);
      setDropFirst(false);
      setDropThird(false);
      setDropFourth(false);
      // setDropFifth(false)
    } else {
      setDropSecond(false);
    }
  };

  const handleThird = () => {
    if (!dropThird) {
      setDropThird(true);
      setDropFirst(false);
      setDropSecond(false);
      setDropFourth(false);
      // setDropFifth(false);
    } else {
      setDropThird(false);
    }
  };

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        fontFamily: "Poppins",
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#091a30",
        },
      }}
      style={{
        fontFamily: "'Poppins', sans-serif",
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <DrawerHeader
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={logo}
          style={{
            height: "80px",
            width: "220px",
            marginTop: "10px",
            marginRight: "15px",
          }}
          alt=""
        />
      </DrawerHeader>

      {/* <HorizontalRule></HorizontalRule> */}

      <List
        className="sidebar-list-container"
        sx={{ fontFamily: "'Poppins', sans-serif" }}
      >
        <HorizontalRule></HorizontalRule>

        {/* <NavLink to="/">
          <ListItem sx={{ fontFamily: "'Poppins', sans-serif" }}>
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
            
                <DashboardIcon className="icon" />
              </ListItemIcon>
              <ListItemText
                primary="Dashboard"
                onClick={handleDashboard}
            
              />
            </ListItemButton>
          </ListItem>
        </NavLink> */}

        {objects?.a15b?.active_fg === "Y" && (
          <NavLink to="/">
            <ListItem>
              <ListItemButton>
                <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                  <DashboardIcon className="icon" />
                </ListItemIcon>
                <ListItemText primary="Dashboard" onClick={handleDashboard} />
              </ListItemButton>
            </ListItem>
          </NavLink>
        )}

        {/* {(userData.ugleve_name === "Admin" ||
          userData.ugleve_name === "Developer") && (
            <ListItemButton className="nested-list" onClick={handleFirst}>
              <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                <SecurityIcon
                  style={{ color: select === 2 ? "#ec1a25" : "#FFFFFF" }}
                  className="icon"
                />
              </ListItemIcon>
              <ListItemText
                primary="Security"
                style={{ color: select === 2 ? "#ec1a25" : "#FFFFFF" }}
              />
              {dropFirst ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          )} */}

        {/* //! security part start */}
        {(objects?.a2b?.active_fg === "Y" ||
          objects?.a3b?.active_fg === "Y" ||
          objects?.a4b?.active_fg === "Y" ||
          objects?.a5b?.active_fg === "Y") && (
          <ListItemButton className="nested-list" onClick={handleFirst}>
            <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
              <SecurityIcon
                style={{ color: select === 2 ? "#ec1a25" : "#FFFFFF" }}
                className="icon"
              />
            </ListItemIcon>
            <ListItemText
              primary="Security"
              style={{ color: select === 2 ? "#ec1a25" : "#FFFFFF" }}
            />
            {dropFirst ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}

        <Collapse in={dropFirst} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            className="sidebar-list-container"
          >
            {/* <NavLink to="security/user-level">
              <ListItem onClick={() => setSelect(2)}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                    <GoDotFill  className="drop-icon" />
                  </ListItemIcon>
                  <ListItemText primary="User Level" />
                </ListItemButton>
              </ListItem>
            </NavLink> */}
            {objects?.a3b?.active_fg === "Y" && (
              // {objects["1Object"]?.active_fg === "Y" && (
              <NavLink to="security/user-level">
                <ListItem onClick={() => setSelect(2)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="User Level" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}
            <NavLink to="security/level-management">
              <ListItem onClick={() => setSelect(2)}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                    <GoDotFill className="drop-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Level Management" />
                </ListItemButton>
              </ListItem>
            </NavLink>
            {objects?.a5b?.active_fg === "Y" && (
              // {objects["5Object"]?.active_fg === "Y" && (
              <NavLink to="security/menu-setup">
                <ListItem onClick={() => setSelect(2)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Module Setup" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}
            {objects?.a2b?.active_fg === "Y" && (
              <NavLink to="security/submenu-setup">
                <ListItem onClick={() => setSelect(2)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Submenu Setup" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}
          </List>
        </Collapse>
        {/* //! security part end */}

        {/* <ListItemButton className="nested-list" onClick={handleSecond}>
          <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
            <SettingsApplicationsIcon
              style={{ color: select === 3 ? "#ec1a25" : "#FFFFFF" }}
              className="icon"
            />
          </ListItemIcon>
          <ListItemText
            style={{ color: select === 3 ? "#ec1a25" : "#FFFFFF" }}
            primary="Setup"
          />
          {dropSecond ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton> */}
        {/* //! setup part start */}
        {(objects?.a6b?.active_fg === "Y" ||
          objects?.a7b?.active_fg === "Y" ||
          objects?.a8b?.active_fg === "Y" ||
          objects?.a9b?.active_fg === "Y") && (
          <ListItemButton className="nested-list" onClick={handleSecond}>
            <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
              <SettingsApplicationsIcon
                className="icon"
                style={{ color: select === 3 ? "#ec1a25" : "#FFFFFF" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Setup"
              style={{ color: select === 3 ? "#ec1a25" : "#FFFFFF" }}
            />
            {dropSecond ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={dropSecond} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            className="sidebar-list-container"
          >
            {/* {(userData.ugleve_name === "Admin" ||
              userData.ugleve_name === "Developer") && (
              <NavLink to="setup/user-setup">
                <ListItem onClick={() => setSelect(3)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill  className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="User Setup" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )} */}

            {objects?.a6b?.active_fg === "Y" && (
              <div>
                {(userData.ugleve_name === "Admin" ||
                  userData.ugleve_name === "Developer") && (
                  <NavLink to="setup/user-setup">
                    <ListItem onClick={() => setSelect(3)}>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                          <GoDotFill className="drop-icon" />
                        </ListItemIcon>
                        <ListItemText primary="User Setup" />
                      </ListItemButton>
                    </ListItem>
                  </NavLink>
                )}
              </div>
            )}

            {/* <NavLink to="setup/occupation-setup">
              <ListItem onClick={() => setSelect(3)}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                    <GoDotFill  className="drop-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Occupation Setup" />
                </ListItemButton>
              </ListItem>
            </NavLink> */}

            {objects?.a7b?.active_fg === "Y" && (
              <NavLink to="setup/occupation-setup">
                <ListItem onClick={() => setSelect(3)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Occupation Setup" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}

            {/* {(userData.ugleve_name === "Admin" ||
              userData.ugleve_name === "Developer") && (
              <NavLink to="setup/sponsor-setup">
                <ListItem onClick={() => setSelect(3)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill  className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Sponsor Setup" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )} */}

            {objects?.a8b?.active_fg === "Y" && (
              <div>
                {(userData.ugleve_name === "Admin" ||
                  userData.ugleve_name === "Developer") && (
                  <NavLink to="setup/sponsor-setup">
                    <ListItem onClick={() => setSelect(3)}>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                          <GoDotFill className="drop-icon" />
                        </ListItemIcon>
                        <ListItemText primary="Sponsor Setup" />
                      </ListItemButton>
                    </ListItem>
                  </NavLink>
                )}
              </div>
            )}

            {/* {(userData.ugleve_name === "Admin" ||
              userData.ugleve_name === "Developer") && (
              <NavLink to="setup/study-setup">
                <ListItem onClick={() => setSelect(3)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill  className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Study Setup" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )} */}
            {objects?.a9b?.active_fg === "Y" && (
              <div>
                {(userData.ugleve_name === "Admin" ||
                  userData.ugleve_name === "Developer") && (
                  <NavLink to="setup/study-setup">
                    <ListItem onClick={() => setSelect(3)}>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                          <GoDotFill className="drop-icon" />
                        </ListItemIcon>
                        <ListItemText primary="Study Setup" />
                      </ListItemButton>
                    </ListItem>
                  </NavLink>
                )}
              </div>
            )}

            {objects?.a18b?.active_fg === "Y" && (
              <div>
                {(userData.ugleve_name === "Admin" ||
                  userData.ugleve_name === "Developer") && (
                  <NavLink to="setup/remark-setup">
                    <ListItem onClick={() => setSelect(3)}>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                          <GoDotFill className="drop-icon" />
                        </ListItemIcon>
                        <ListItemText primary="Remark Setup" />
                      </ListItemButton>
                    </ListItem>
                  </NavLink>
                )}
              </div>
            )}

            {/* trial setup */}
            <div>
              {(userData.ugleve_name === "Admin" ||
                userData.ugleve_name === "Developer") && (
                <NavLink to="setup/trial-setup">
                  <ListItem onClick={() => setSelect(3)}>
                    <ListItemButton sx={{ pl: 4 }}>
                      <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                        <GoDotFill className="drop-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Trial Setup" />
                    </ListItemButton>
                  </ListItem>
                </NavLink>
              )}
            </div>

            {/* {(userData.ugleve_name === "Admin" ||
              userData.ugleve_name === "Developer") && (
                <NavLink to="setup/employee-setup">
                  <ListItem onClick={() => setSelect(3)}>
                    <ListItemButton sx={{ pl: 4 }}>
                      <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                        <GoDotFill  className="drop-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Employee Setup" />
                    </ListItemButton>
                  </ListItem>
                </NavLink>
              )} */}

            {objects?.a17b?.active_fg === "Y" && (
              <>
                {(userData.ugleve_name === "Admin" ||
                  userData.ugleve_name === "Developer") && (
                  <NavLink to="setup/thana-setup">
                    <ListItem onClick={() => setSelect(3)}>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                          <GoDotFill className="drop-icon" />
                        </ListItemIcon>
                        <ListItemText primary="Thana Setup" />
                      </ListItemButton>
                    </ListItem>
                  </NavLink>
                )}
              </>
            )}
          </List>
        </Collapse>
        {/* //! setup part end */}
        {/* 
        <ListItemButton className="nested-list" onClick={handleThird}>
          <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
            <ListAltIcon
              style={{ color: select === 4 ? "#ec1a25" : "#FFFFFF" }}
              className="icon"
            />
          </ListItemIcon>
          <ListItemText
            primary="Volunteer Bank"
            style={{ color: select === 4 ? "#ec1a25" : "#FFFFFF" }}
          />
          {dropThird ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton> */}

        {/* //! volunteer bank start */}
        {(objects?.a10b?.active_fg === "Y" ||
          objects?.a11b?.active_fg === "Y" ||
          objects?.a12b?.active_fg === "Y") && (
          <ListItemButton className="nested-list" onClick={handleThird}>
            <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
              <ListAltIcon
                className="icon"
                style={{ color: select === 4 ? "#ec1a25" : "#FFFFFF" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Volunteer Bank"
              style={{ color: select === 4 ? "#ec1a25" : "#FFFFFF" }}
            />
            {dropThird ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}

        <Collapse in={dropThird} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            className="sidebar-list-container"
          >
            {/* <NavLink to="/volunteer/volunteerRegister">
              <ListItem onClick={() => setSelect(4)}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                    <GoDotFill  className="drop-icon" />
                  </ListItemIcon>
                  <ListItemText primary="New Registration" />
                </ListItemButton>
              </ListItem>
            </NavLink> */}
            {objects?.a10b?.active_fg === "Y" && (
              <NavLink to="/volunteer/volunteerRegister">
                <ListItem onClick={() => setSelect(4)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="New Registration" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}
            {/* <NavLink to="/volunteer/VolunteerPro">
              <ListItem onClick={() => setSelect(4)}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                    <GoDotFill  className="drop-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Registration From PRO" />
                </ListItemButton>
              </ListItem>
            </NavLink> */}
            {objects?.a11b?.active_fg === "Y" && (
              <NavLink to="/volunteer/VolunteerPro">
                <ListItem onClick={() => setSelect(4)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Registration From PRO" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}
            {/* <NavLink to="/volunteer/volunteerBank">
              <ListItem onClick={() => setSelect(4)}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                    <GoDotFill  className="drop-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Approved Volunteer" />
                </ListItemButton>
              </ListItem>
            </NavLink> */}
            {objects?.a12b?.active_fg === "Y" && (
              <NavLink to="/volunteer/volunteerBank">
                <ListItem onClick={() => setSelect(4)}>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                      <GoDotFill className="drop-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Volunteer Bank" />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            )}
          </List>
        </Collapse>
        {/* //! volunteer part end */}

        <NavLink to="/trial">
          <ListItem>
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                <FaNotesMedical className="icon" />
              </ListItemIcon>
              <ListItemText primary="Trial" onClick={handleDashboard} />
            </ListItemButton>
          </ListItem>
        </NavLink>

        <NavLink to="/volunteerFromWeb">
          <ListItem>
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "fit-content", pr: 1 }}>
                <MdVolunteerActivism className="icon" />
              </ListItemIcon>
              <ListItemText
                primary="Volunteers From Website"
                onClick={handleDashboard}
              />
            </ListItemButton>
          </ListItem>
        </NavLink>

        {/* <NavLink to="/study">
          <ListItem sx={{ fontFamily: "'Poppins', sans-serif" }}>
            <ListItemButton>
              <ListItemIcon>
                <HistoryEduIcon className="icon" />
              </ListItemIcon>
              <ListItemText primary="Study Compliance" onClick={handleFourth} />
            </ListItemButton>
          </ListItem>
        </NavLink> */}
      </List>
    </Drawer>
  );
};

export default Sidebar;
